import { render, staticRenderFns } from "./ArchiveEvents.vue?vue&type=template&id=297c7fc9"
import script from "./ArchiveEvents.vue?vue&type=script&lang=js"
export * from "./ArchiveEvents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports